import { createI18n,useI18n } from 'vue-i18n'

import en from './en'
import zh from './zh'

// 语言库
const messages = {
  'en-US':en,
  'zh-CN':zh,
}
const _locale = localStorage.getItem('lang') || 'zh-CN'


//创建i18n对象
const i18n = createI18n({
  locale: _locale, //默认显示的语言
  fallbackLocale:'en-US', //预设语言环境
  globalInjection: true, //全局生效$ts
  silentFallbackWarn: true, //抑制警告
  silentTranslationWarn: true, //抑制警告
  missingWarn: false,
  fallbackWarn: false,
  legacy:false,
  messages
});
const { t,locale } = i18n.global
;
export {t,locale};
export default i18n;


